import Marquee from "react-fast-marquee";
import { tickerStocks } from "../lib/data";
import { TrendingUp, TrendingDown } from "lucide-react";

export default function LiveMarketTicker() {
  return (
    <div
      data-testid="market-ticker"
      className="relative border-y border-white/10 bg-[#0A0F24]/80 backdrop-blur-md py-3 z-30"
    >
      <Marquee speed={45} gradient={false} pauseOnHover>
        {tickerStocks.concat(tickerStocks).map((t, i) => {
          const up = t.chg >= 0;
          return (
            <div key={i} className="flex items-center gap-3 px-8 border-r border-white/5">
              <span className="text-sm font-bold tracking-wide text-slate-200">{t.sym}</span>
              <span className="font-mono text-sm text-slate-300">
                {t.price.toLocaleString("en-IN")}
              </span>
              <span className={`inline-flex items-center gap-1 text-xs font-bold font-mono ${up ? "text-emerald-400" : "text-red-400"}`}>
                {up ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
                {up ? "+" : ""}{t.chg.toFixed(2)}%
              </span>
            </div>
          );
        })}
      </Marquee>
    </div>
  );
}
